import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';

export const useEnabledWheelByRarity = () => {
  const {
    flags: {
      marketDailyWheelBySportAndRarity = {
        baseball: { limited: false, common: false },
        football: { limited: false, common: false },
        nba: { limited: false, common: false },
      },
    },
  } = useFeatureFlags();
  const { sport } = useSportContext();
  return {
    limited: marketDailyWheelBySportAndRarity[sport.toLowerCase()]?.limited,
    common: marketDailyWheelBySportAndRarity[sport.toLowerCase()]?.common,
  };
};
